import { render, staticRenderFns } from "./ConversationsTable.vue?vue&type=template&id=00aa1e98&scoped=true&"
import script from "./conversations-table.ts?vue&type=script&lang=ts&"
export * from "./conversations-table.ts?vue&type=script&lang=ts&"
import style0 from "./conversations-table.scss?vue&type=style&index=0&id=00aa1e98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aa1e98",
  null
  
)

export default component.exports